<div class="card-body flex flex-col">
  @if(investigationResults().length > 0 ){
  <div class="card-title mb-5">
    <div class="flex justify-between items-center mb-5">
      <span class="text-xl font-bold text-primary">{{
        "CASE_DETAIL.INVESTIGATOR_RESULTS" | translate
      }}</span>
       @if (apiUrl.includes('coreact')) {
         <span class="text-lg font-semibold">
        {{ "CASE_DETAIL.SAVED_AMOUNT" | translate }}: {{ savedAmount }} €
      </span>}
    </div>
    <hr />
  </div>
  <div class="w-full overflow-x-auto">
    <table class="w-full text-left table-auto min-w-[760px] md:min-w-0">
      <thead class="thead-light">
        <tr>
          <th class="font-bold text-lg text-inverse-primary">
            <!-- Details -->
          </th>
          <th class="font-bold text-lg text-inverse-primary">
            {{ "CASE_DETAIL.INVESTIGATOR" | translate }}
          </th>
          <th class="font-bold text-lg text-inverse-primary">
            {{ "CASE_DETAIL.RESULTS" | translate }}
          </th>
          <th class="font-bold text-lg text-inverse-primary">
            {{ "CASE_DETAIL.FILES" | translate }}
          </th>
          @if(claimStatus()!=='Approved' && claimStatus()!=='Rejected' && !isCaseDetailReadOnly) {
          <th class="font-bold text-lg text-inverse-primary"></th>
          <th class="font-bold text-lg text-inverse-primary"></th>
          }
        </tr>
      </thead>
      <tbody>
        @for( comment of investigationResults(); track $index; let
        rowIndex=$index){
        <tr>
          <td>
            @if(comment.comment){
            <a
              href="javascript:void(0)"
              class="expand-collapse-icon ps-3"
              title="Expand/Collapse Row"
              (click)="toggleExpandRow(rowIndex)"
            >
              <i
                [class]="
                  expandedRowIndex === rowIndex
                    ? 'fa fa-chevron-circle-down text-primary text-xl'
                    : 'fa fa-chevron-circle-right text-success text-xl'
                "
              ></i>
            </a>
            }
          </td>
          <td>
            <span class="text-lg text-dark text-center">{{
              comment.investigator
            }}</span>
          </td>

          <td>
            <div class="flex flex-row flex-wrap gap-2 items-center">
              @for( tag of comment.tags;track $index ){
              <lib-chip [tag]="tag" />
              }
            </div>
          </td>

          <td>
            <div class="flex flex-col gap-2">
              @for(file of comment.files; track $index){
              <div class="flex items-center gap-2">
                <img
                  [src]="getImage(file)"
                  width="30"
                  alt="File Preview"
                  class="cursor-pointer"
                  (click)="downloadFile(file)"
                />
              </div>
              }
            </div>
          </td>
          @if(claimStatus()!=='Approved' && claimStatus()!=='Rejected' && !isCaseDetailReadOnly) {
          <td class="text-center">
            <i
              class="fa fa-pen cursor-pointer text-dark"
              (click)="openComments(comment)"
            ></i>
          </td>
          @if(comment.visibilityStatus === 'Temporary'){
          <td class="text-center">
            <button
              pButton
              class="!text-white"
              (click)="updateVisibilityStatusToPermanent(comment)"
            >
              {{ "CASE_DETAIL.SUBMIT" | translate }}
              <i class="ml-5 fa fa-check cursor-pointer text-white"></i>
            </button>
          </td>
          }@else{
          <td class="text-center">
            <button pButton class="!text-white" disabled>
              {{ "CASE_DETAIL.SUBMITTED" | translate }}
              <i class="ml-5 fa fa-ban text-white"></i>
            </button>
          </td>
          } }
        </tr>
        @if(expandedRowIndex === rowIndex){
        <!--  -->
        @if(comment.visibilityStatus === 'Temporary'){
        <tr>
          <td colspan="6" class="bg-light">
            <div class="p-3">
              <h6 class="font-semibold">
                {{ "CASE_DETAIL.INVESTIGATOR'S_COMMENTS" | translate }}:
              </h6>
              <p>
                <i class="fa-solid fa-comments mr-2 text-dark"></i>
                {{ comment.comment }}
              </p>
            </div>
          </td>
        </tr>
        } @else {
        <tr>
          <td colspan="6" class="bg-light">
            <div class="p-3">
              <h6 class="font-semibold">
                {{ "CASE_DETAIL.INVESTIGATOR'S_COMMENTS" | translate }}:
              </h6>
              <p>
                <i class="fa-solid fa-comments mr-2 text-dark"></i>
                {{ comment.comment }}
              </p>
            </div>
          </td>
        </tr>
        }
        }
        }
      </tbody>
    </table>
  </div>

  @if(showInvestigationResultModal()){
  <lib-investigation-result-modal
    [header]="'CASE_DETAIL.EDIT_COMMENT' | translate"
    [(showModal)]="showInvestigationResultModal"
    [selectedInvestigationResult]="selectedInvestigationResult()"
    [investigationStatuses]="investigationStatuses"
    [showChips]="true"
    (onFileRemove)="onRemoveFile($event)"
    (onTagRemove)="removeTag($event.id)"
    (onFileUpload)="uploadFiles($event)"
    (onSubmit)="submitEdit($event)"
    (onDeleteComment)="deleteCommentById($event)"
    [savedAmount]="savedAmount"
    (savedAmountChange)="updateSavedAmount($event)"
  />
  }

  } @else {
  <div class="card-title mb-5">
    <div class="flex justify-between items-center mb-5">
      <span class="text-xl font-bold text-primary">{{
        "CASE_DETAIL.INVESTIGATOR_RESULTS" | translate
      }}</span>
    </div>
    <hr />
  </div>

  <div class="text-center">
    <span class="text-muted fs-4">{{
      "CASE_DETAIL.NO_INVESTIGATOR_RESULTS" | translate
    }}</span>
  </div>
  }
</div>
